
import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';

export const followItemActionControl: ControlFacet<{
  itemKey: string;
}, {
  isAvailable: boolean;
  onFollow?: () => IItemCacheThunkAction<void>;
}> = new ControlFacet('followItemActionControl');
